import { render, staticRenderFns } from "./StoreChooser.vue?vue&type=template&id=ef65019c&scoped=true&"
import script from "./StoreChooser.vue?vue&type=script&lang=js&"
export * from "./StoreChooser.vue?vue&type=script&lang=js&"
import style0 from "./StoreChooser.vue?vue&type=style&index=0&id=ef65019c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef65019c",
  null
  
)

export default component.exports